import { createSlice } from "@reduxjs/toolkit";

export const ActiveTab = createSlice({
  name: "drawerTabs",
  initialState: {
    tabs: {

      client: "company_list",
      productList: "product_list",
      catalogue: "ecommerce_category",
      sales: "summary",
      notification: "notification",
      subscription: "invoice",
      admin_setting: "personal",
      clientUsers: "clientList",
      clientCatalogue: "service",
      teams: "teamMemebrs",
      client_setting: "personal",
      marketPlace: "profiles",
      branch: "branch",
      blogs: "blog_list",
      contentHub: "content_list",
      },
  },
  reducers: {
    setActiveTab: (state, action) => {
      state.tabs = action.payload;
    },
  },
});

export const { setActiveTab } = ActiveTab.actions;

export default ActiveTab.reducer;
